export function cloneData1D(datum) {
    const { x, re, im } = datum || { x: [], re: [], im: [] };
    return { x: x.slice(), re: re.slice(), im: im?.slice() || null };
}
//# sourceMappingURL=cloneData1D.js.map